/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateTemporaryGrantForm,
  CreateTemporaryGrantForm$Outbound,
  CreateTemporaryGrantForm$outboundSchema,
} from "../components/createtemporarygrantform.js";

export type CreateTemporaryGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateTemporaryGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createTemporaryGrantForm: CreateTemporaryGrantForm;
};

/** @internal */
export type CreateTemporaryGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateTemporaryGrantSecurity$outboundSchema: z.ZodMiniType<
  CreateTemporaryGrantSecurity$Outbound,
  CreateTemporaryGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createTemporaryGrantSecurityToJSON(
  createTemporaryGrantSecurity: CreateTemporaryGrantSecurity,
): string {
  return JSON.stringify(
    CreateTemporaryGrantSecurity$outboundSchema.parse(
      createTemporaryGrantSecurity,
    ),
  );
}

/** @internal */
export type CreateTemporaryGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateTemporaryGrantForm: CreateTemporaryGrantForm$Outbound;
};

/** @internal */
export const CreateTemporaryGrantRequest$outboundSchema: z.ZodMiniType<
  CreateTemporaryGrantRequest$Outbound,
  CreateTemporaryGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createTemporaryGrantForm: CreateTemporaryGrantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createTemporaryGrantForm: "CreateTemporaryGrantForm",
    });
  }),
);

export function createTemporaryGrantRequestToJSON(
  createTemporaryGrantRequest: CreateTemporaryGrantRequest,
): string {
  return JSON.stringify(
    CreateTemporaryGrantRequest$outboundSchema.parse(
      createTemporaryGrantRequest,
    ),
  );
}
